import isInstanceReduxUtil from '../../../redux/utils/is-instance'
import isLoadedReduxUtil from '../../../redux/utils/is-loaded'
import hasLoadedAssociationsReduxUtil from '../../../redux/utils/has-loaded-associations'

function isDeeplyLoadedReduxUtil (instance) {
  if (!isInstanceReduxUtil(instance)) {
    return false
  }

  if (!isLoadedReduxUtil(instance)) {
    return false
  }

  return hasLoadedAssociationsReduxUtil(instance)
}

export default isDeeplyLoadedReduxUtil
